import React from 'react';
import { get,  } from 'lodash';
import { callItemDetailInnerWidget as CallItemDetailInnerWidgetView } from 'ui/views/widgets/callItemDetailInnerWidget';
import { CallItemDetailInnerWidgetService } from 'services/CallItemDetailInnerWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CallItemDetailInnerWidget } from 'ui/containers/CallItemDetailInnerWidget';
 *
 * // render
 * <CallItemDetailInnerWidget propName='propValue'/>
 */
export class CallItemDetailInnerWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        
        this.callItemDetailInnerWidgetService = new CallItemDetailInnerWidgetService();
        this.state={
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
            requestPayload: { data: this.props.widget.requestPayload, ...this.props.requestPayload }
        };
        if( this.state.requestPayload ) {
            this.fetchComponentData(); // start component data fetch
        }
        
    }

    /**
	 * @desc Fetch component response.
	 */
    async fetchComponentData() {

        log.debug( 'CallItemDetailInnerTab.fetchComponentData()' );

        // cancel ongoing request
        this.callItemDetailInnerWidgetService.cancel();

        // get status and service data
        const { status, data } = await this.callItemDetailInnerWidgetService.fetchComponentData( {
            url: this.props.widget.url
        } );
        
        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CallItemDetailInnerWidgetView
            isFetching={ this.state.isFetching }
            networkStatus={ this.state.networkStatus }
            { ...get( this.state, 'componentData', {} ) }
            requestPayload={  this.state.requestPayload }/>
        );
    }
}

// set display name
CallItemDetailInnerWidget.displayName = 'CallItemDetailInnerWidget';

// set default props
CallItemDetailInnerWidget.defaultProps = {};

// prop types
CallItemDetailInnerWidget.propTypes = {};
